export default [
    {
        'code' : '002',
        'name' : 'ธนาคารกรุงเทพ',
        'image' : require('@/assets/images/banking/bbl.svg'),
    },
    {
        'code' : '006',
        'name' : 'ธนาคารกรุงไทย',
        'image' : require('@/assets/images/banking/ktb.svg'),
    },
    {
        'code' : '025',
        'name' : 'ธนาคารกรุงศรีอยุธยา',
        'image' : require('@/assets/images/banking/bay.svg'),
    },
    {
        'code' : '004',
        'name' : 'ธนาคารกสิกรไทย',
        'image' : require('@/assets/images/banking/kbank.svg'),
    },
    {
        'code' : '069',
        'name' : 'ธนาคารเกียรตินาคิน',
        'image' : require('@/assets/images/banking/kk.svg'),
    },
    {
        'code' : '028',
        'name' : 'ธนาคารคาลิยง',
        'image' : require('@/assets/images/banking/cacib.svg'),
    },
    {
        'code' : '008',
        'name' : 'ธนาคารเจพีมอร์แกน เชส',
        'image' : require('@/assets/images/banking/jpm.svg'),
    },
    {
        'code' : '018',
        'name' : 'ธนาคารชูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น',
        'image' : require('@/assets/images/banking/smbc.svg'),
    },
    {
        'code' : '017',
        'name' : 'ธนาคารซิตี้แบงก์',
        'image' : require('@/assets/images/banking/citi.svg'),
    },
    {
        'code' : '022',
        'name' : 'ธนาคารซีไอเอ็มบี ไทย',
        'image' : require('@/assets/images/banking/cimb.svg'),
    },
    {
        'code' : '032',
        'name' : 'ธนาคารดอยซ์แบงก์',
        'image' : require('@/assets/images/banking/db.svg'),
    },
    {
        'code' : '005',
        'name' : 'ธนาคารเดอะรอยัลแบงก์อ๊อฟสกอตแลนด์ เอ็น.วี.',
        'image' : require('@/assets/images/banking/rbs.svg'),
    },
    {
        'code' : '010',
        'name' : 'ธนาคารโตเกียว - มิตซูบิชิ ยูเอฟเจ',
        'image' : require('@/assets/images/banking/mufg.svg'),
    },
    {
        'code' : '011',
        'name' : 'ธนาคารทหารไทย',
        'image' : require('@/assets/images/banking/tmb.svg'),
    },
    {
        'code' : '067',
        'name' : 'ธนาคารทิสโก้',
        'image' : require('@/assets/images/banking/tisco.svg'),
    },
    {
        'code' : '071',
        'name' : 'ธนาคารไทยเครดิต เพื่อรายย่อย',
        'image' : require('@/assets/images/banking/tcrb.svg'),
    },
    {
        'code' : '014',
        'name' : 'ธนาคารไทยพาณิชย์',
        'image' : require('@/assets/images/banking/scb.svg'),
    },
    {
        'code' : '065',
        'name' : 'ธนาคารธนชาต',
        'image' : require('@/assets/images/banking/tbank.svg'),
    },
    {
        'code' : '015',
        'name' : 'ธนาคารนครหลวงไทย',
        'image' : require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code' : '001',
        'name' : 'ธนาคารประเทศไทย',
        'image' : require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code' : '034',
        'name' : 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
        'image' : require('@/assets/images/banking/baac.svg'),
    },
    {
        'code' : '039',
        'name' : 'ธนาคารมิซูโฮ คอร์ปอเรต',
        'image' : require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code' : '026',
        'name' : 'ธนาคารเมกะ สากลพาณิชย์',
        'image' : require('@/assets/images/banking/mega.svg'),
    },
    {
        'code' : '024',
        'name' : 'ธนาคารยูโอบี',
        'image' : require('@/assets/images/banking/uob.svg'),
    },
    {
        'code' : '073',
        'name' : 'ธนาคารแลนด์ แอนด์ เฮ้าส์ เพื่อรายย่อย',
        'image' : require('@/assets/images/banking/lhb.svg'),
    },
    {
        'code' : '020',
        'name' : 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)',
        'image' : require('@/assets/images/banking/sc.svg'),
    },
    {
        'code' : '070',
        'name' : 'ธนาคารสินเอเซีย',
        'image' : require('@/assets/images/banking/non-banking.svg'),
    },
    {
        'code' : '027',
        'name' : 'ธนาคารอเมริกาเนชั่นแนลแอสโซซิเอชั่น',
        'image' : require('@/assets/images/banking/boa.svg'),
    },
    {
        'code' : '030',
        'name' : 'ธนาคารออมสิน',
        'image' : require('@/assets/images/banking/gsb.svg'),
    },
    {
        'code' : '033',
        'name' : 'ธนาคารอาคารสงเคราะห์',
        'image' : require('@/assets/images/banking/ghb.svg'),
    },
    {
        'code' : '066',
        'name' : 'ธนาคารอิสลามแห่งประเทศไทย',
        'image' : require('@/assets/images/banking/ibank.svg'),
    },
    {
        'code' : '031',
        'name' : 'ธนาคารฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น',
        'image' : require('@/assets/images/banking/hsbc.svg'),
    },
    {
        'code': '011',
        'name': 'ธนาคารทหารไทยธนชาต',
        'image' : require('@/assets/images/banking/tmb.svg'),
    },
    {
        'code': '999',
        'name': 'พร้อมเพย์',
        'image' : require('@/assets/images/banking/promptpay.png'),
    }
]